import ax from 'axios';
import _ from 'lodash';

import { API_URL } from '../config';
import { PROPERTY_MAIN_RISKS } from '../constants/propertyCalcConstants';

const URL_PRICE = `${API_URL}/price/property`;

export const requestPrice = (data) => {
  const { propertyType, propertyArea, usePurpose, extraRisks } = data;
  const risks = _.merge(PROPERTY_MAIN_RISKS, extraRisks);

  const payload = {
    propertyType,
    propertyArea,
    purpose: usePurpose.value,
    risks,
  };

  return ax
    .post(URL_PRICE, payload)
    .then((response) => response.data);
};

export default requestPrice;
